module.exports = __webpack_public_path__ + "img/icon_arrowRight.83cd0996.svg";